<template>
  <div class="card-form">
    <el-card class="mt-2">
      <b-row>
        <b-col md="12" lg="4">
          <div>
            <b-img
              :src="$osscdn(defaultImageCode) || '/image/static/img/nopic.jpg'"
              @click="imageView"
              class="main-image"
            ></b-img>
          </div>
          <div v-show="false" class="images" v-viewer="{ movable: false }">
            <img
              v-for="(item, index) in imageList"
              :src="$osscdn(item.resImageCode) || '/image/static/img/nopic.jpg'"
              :key="index"
            />
          </div>
          <b-row class="mt-3">
            <div v-for="(item, index) in imageList" :key="index">
              <div
                class="small-imgbox mb-3"
                @click="changeImage(item.resImageCode)"
              >
                <img
                  :src="
                    $osscdn(item.resImageCode) || '/image/static/img/nopic.jpg'
                  "
                />
              </div>
            </div>
          </b-row>
        </b-col>
        <b-col md="12" lg="8">
          <h3>{{ formData.resNo }}</h3>
          <div>
            <b-icon-star
              v-for="(str, index) in formData.lightStarList"
              :key="index"
              :variant="str"
              class="mr-1"
            ></b-icon-star>
            <b-icon-star
              v-for="str in formData.greyStarList"
              :key="str"
              class="mr-3"
            ></b-icon-star>
            <span>{{ formData.reviews }} reviews</span>
          </div>
          <hr />
          <h6 class="m-t-0">
            {{ $l('form_label_name_cn') || '中文名称' }}：{{
              formData.resName ? formData.resName : '--'
            }}
          </h6>
          <p class="product-description">
            {{ $l('form_label_name_en') || '英文名称' }}：{{
              formData.resNameEn ? formData.resNameEn : '--'
            }}
          </p>
          <p class="mb-1">
            {{ $l('form_label_marketRegion') || '市场地区' }}：{{
              formData.marketRegion ? formData.marketRegion : '--'
            }}
          </p>
          <p class="mb-1">
            {{ $l('form_label_brand') || '产品品牌' }}：{{
              formData.brand ? formData.brand : '--'
            }}
          </p>
          <p class="mb-1">
            {{ $l('form_label_storeName') || '销售门店' }}：{{
              formData.storeName ? formData.storeName : '--'
            }}
          </p>
          <b-row class="mt-2">
            <b-col sm="12" lg="6">
              <div>
                <p class="mb-1">
                  {{ $l('form_label_saleYear') || '上市年份' }}：{{
                    formData.saleYear ? formData.saleYear : '--'
                  }}
                </p>
              </div>
            </b-col>
            <b-col sm="12" lg="6">
              <div>
                <p class="mb-1">
                  {{ $l('form_label_saleSeason') || '上市季节' }}：{{
                    formData.saleSeason ? formData.saleSeason : '--'
                  }}
                </p>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col sm="12" lg="6">
              <div>
                <p class="mb-1">
                  {{ $l('form_label_rmbSalePrice') || '人民币价格' }}：{{
                    formData.rmbSalePrice ? formData.rmbSalePrice : '--'
                  }}
                  / RMB
                </p>
              </div>
            </b-col>
            <b-col sm="12" lg="6">
              <div>
                <p class="mb-1">
                  {{ $l('form_label_regionSalePrice') || '地区价格' }}：{{
                    formData.regionSalePrice ? formData.regionSalePrice : '--'
                  }}
                  / {{ formData.currency }}
                </p>
              </div>
            </b-col>
          </b-row>
          <p class="mb-1 mt-1">
            {{ $l('form_label_composition') || '成分构成' }}：{{
              formData.composition ? formData.composition : '--'
            }}
          </p>
          <p class="mb-1">
            {{ $l('form_label_remarks') || '备注说明' }}：{{
              formData.resMemo ? formData.resMemo : '--'
            }}
          </p>
          <p
            class="mb-1"
            v-for="(item, index) in formData.researchInfoAttributeList"
            :key="index"
          >
            {{ item.label }}：{{ item.value ? item.value : '--' }}
          </p>
          <hr style="background-color:#e5e5e6;height:1px;border:none;" />
          <div class="action">
            <button
              class="btn btn-outline-success"
              type="button"
              @click="addCart()"
            >
              Add to Cart
            </button>
            <button
              class="btn btn-outline-danger"
              style="margin-left: 10px;"
              type="button"
              @click="addCollect()"
            >
              <i v-if="!formData.state" class="fa fa-heart-o"></i>
              <i v-else class="fa fa-heart" style="color: red"></i>
            </button>
          </div>
        </b-col>
      </b-row>
    </el-card>
  </div>
</template>
<script>
import InfoImage from './components/image'
import Attribute from '@/views/digital/components/attribute'
export default {
  computed: {
    attrParams() {
      return {
        infoCode: this.formData.resCode,
        templateCategoryCode: this.formData.categoryCode,
        masterCategoryCode: this.formData.categoryCode,
        templateType: 'R'
      }
    }
  },
  components: {
    InfoImage,
    Attribute
  },
  // 数据
  data() {
    return {
      defaultImageCode: '',
      resCode: '',
      formData: {},
      productType: 'R',
      imageList: []
    }
  },
  activated() {
    this.init()
    this.detailLoad(this.$route.params.resCode)
  },
  // 生命周期钩子
  mounted() {
    this.init()
    this.detailLoad(this.$route.params.resCode)
  },
  // 事件处理方法
  methods: {
    init() {
      this.resCode = ''
      this.defaultImageCode = ''
      this.imageList = []
    },
    detailLoad(val) {
      let param = { resCode: val }
      this.$api.researchInfoDetailApi(param).then((res) => {
        this.formData = res.body
        this.loadImageData()
      })
    },
    loadImageData() {
      this.$api
        .imageListResearchInfoApi({ resCode: this.formData.resCode })
        .then((res) => {
          this.imageList = res.body.data
          if (this.formData.resImageCode) {
            this.imageList.push({
              createTime: '',
              resCode: '',
              resImageUrl: '',
              seqno: '',
              sortOrder: '',
              resImageCode: this.formData.resImageCode
            })
            this.defaultImageCode = this.imageList[0].resImageCode
          }
        })
    },
    // 点击大图显示图片预览组件
    imageView() {
      if (this.defaultImageCode) {
        const viewer = this.$el.querySelector('.images').$viewer
        viewer.show()
      }
    },
    // 变换产品图
    changeImage(resImageCode) {
      this.defaultImageCode = resImageCode
    },
    // 加入收藏/取消收藏
    addCollect() {
      let param = {
        sampleCode: this.formData.resCode,
        productType: this.productType
      }
      this.$api
        .saveAndCancelCollectApi(param)
        .then(() => {
          this.$set(this.formData, 'state', !this.formData.state)
          if (this.formData.state) {
            this.$message.success(this.$l('tips_collection_ok') || '收藏成功')
          } else {
            this.$message.success(
              this.$l('tips_collection_cancle') || '取消收藏'
            )
          }
        })
        .catch(() => {})
    },
    addCart() {
      this.$api
        .addCartApi({
          sampleCode: this.formData.resCode,
          productType: this.productType
        })
        .then(() => {
          this.$message.success(
            this.$l('tips_add_cart_ok') || '购物车添加成功！'
          )
        })
        .catch(() => {})
    },
    goBack() {
      this.$router.go(-1)
    }
  }
}
</script>

<style lang="scss">
.small-imgbox {
  border: 1px solid #dcdfe6;
  border-radius: 4px;
  position: relative;
  width: 90px;
  height: 90px;
  float: left;
  margin-right: 10px;
}
.small-imgbox img {
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  max-width: 100%;
  max-height: 100%;
}
.image {
  width: 100%;
  display: block;
}
.main-image {
  margin: auto;
  max-width: 100%;
  max-height: 320px;
  display: block;
}
</style>
